import styled from "styled-components"
import InnerHTML from "dangerously-set-html-content"

export const Wrapper = styled(InnerHTML)`
  margin-bottom: 6rem;
`
